export default __webpack_public_path__ + "static/media/SC-GN01-0.66bf475b.jpg";